import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import goToImage from './media/go-to.svg';

import styles from './PrimaryButton.module.scss';

const PrimaryButton: FC<IProps> = (props) => {
    if (props.href) {
        return (
            <a
                href={props.href}
                className={
                    classNames(styles.primaryButton, styles.link, props.className, {
                        [styles.isDisabled]: props.isDisabled,
                    })
                }
            >
                {props.text}
                <img
                    className={styles.goToImage}
                    src={goToImage}
                    alt={'Go to'}
                />
            </a>
        );
    }

    return (
        <button
            type={'button'}
            className={
                classNames(styles.primaryButton, props.className, {
                    [styles.isDisabled]: props.isDisabled,
                })
            }
            disabled={props.isDisabled}
            onClick={props.onClick}
        >
            {props.text}
        </button>
    );
};

export default PrimaryButton;
